export default "__VITE_ASSET__DvZzs35B__"